
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recept/[id]/[[...slug]]",
      function () {
        return require("private-next-pages/recept/[id]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recept/[id]/[[...slug]]"])
      });
    }
  